import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseTextGroup = {
  rowGap: css`var(--cse-text-group-row-gap, ${csSpacing.spacing05})`,
  headingGap: css`var(--cse-text-group-heading-gap, ${csSpacing.spacing02})`,
}

export const style: CSSResult = css`
  .cse-text-group {
    display: flex;
    flex-direction: column;
    row-gap: ${cseTextGroup.rowGap};
  }

  .cse-text-group__heading {
    display: flex;
    flex-direction: column;
    row-gap: ${cseTextGroup.headingGap};
  }

  .alignment-left {
    --cse-text-text-align: left;

    align-items: flex-start;
    text-align: left;
  }

  .alignment-center {
    --cse-text-text-align: center;

    align-items: center;
    text-align: center;
  }

  .alignment-right {
    --cse-text-text-align: right;

    align-items: flex-end;
    text-align: right;
  }
`
